import React from 'react'
import { MetricContainer } from '../components/MetricContainer/MetricContainer'
import Styles from './GenderDistribution.module.scss'
import PieChart from '../components/PieChart/PieChart'
import { Spin } from 'common/Spin/Spin'
import { Heading } from 'blaze-ui/Heading/Heading'
import { Text } from 'blaze-ui/Text/Text'

interface GenderDistributionProps {
  data?: {
    gender_distribution: {
      male: number
      female: number
      unknown: number
    }
    error_title?: string
    error_message?: string
  }
  isFetching: boolean
}

export const GenderDistribution: React.FC<GenderDistributionProps> = ({ data, isFetching }) => {
  const chartData = data
    ? [
        {
          name: 'Male',
          value: data.gender_distribution.male,
          colors: {
            border: 'rgba(0, 119, 255, 0.80)',
            inner: 'rgba(0, 119, 255, 0.10)',
          },
        },
        {
          name: 'Female',
          value: data.gender_distribution.female,
          colors: {
            border: 'rgba(255, 0, 17, 0.40)',
            inner: 'rgba(255, 0, 17, 0.10)',
          },
        },
        {
          name: 'Did not share',
          value: data.gender_distribution.unknown,
          colors: {
            border: 'rgba(95, 145, 201, 0.33)',
            inner: 'rgba(95, 145, 201, 0.10)',
          },
        },
      ]
    : []

  const isEmpty = data && data.gender_distribution.unknown === 100

  let content
  if (isFetching) {
    content = (
      <div className={Styles.container} data-testid="loading">
        <Spin />
      </div>
    )
  } else if (!data) {
    content = <div className={Styles.container}>Error loading data</div>
  } else if (data && data.error_title && data.error_message) {
    content = (
      <div className={Styles.errorContainer}>
        <Heading level={5}>{data.error_title}</Heading>
        <Text>{data.error_message}</Text>
      </div>
    )
  } else if (isEmpty) {
    content = <div className={Styles.loadingContainer}>This data isn't ready yet, check back soon!</div>
  } else {
    content = (
      <div className={Styles.container} data-testid="gender-distribution-chart">
        <PieChart data={chartData} />
      </div>
    )
  }

  return (
    <MetricContainer name="Audience by Gender" tooltip="Distribution of audience by gender">
      {content}
    </MetricContainer>
  )
}
